<!-- ===================== MAIN LOGIN ===================== -->
<div class="login-page" *ngIf="!isBool && !aluminiLogin">
  <div class="login-left d-none d-lg-flex">
    <div class="login-left-overlay"></div>
    <div class="login-left-content">
      <img src="../../../assets/img/bharat-logo.png" alt="Bharat BoudhIKS Logo" class="login-brand-logo" />
      <h1 class="login-brand-name">Bharat BoudhIKS</h1>
      <p class="login-brand-tagline">Where Tradition Meets Transformation</p>
      <div class="login-stats">
        <div class="login-stat-item">
          <span class="login-stat-number">10K+</span>
          <span class="login-stat-label">Students</span>
        </div>
        <div class="login-stat-divider"></div>
        <div class="login-stat-item">
          <span class="login-stat-number">200+</span>
          <span class="login-stat-label">Courses</span>
        </div>
        <div class="login-stat-divider"></div>
        <div class="login-stat-item">
          <span class="login-stat-number">50+</span>
          <span class="login-stat-label">Departments</span>
        </div>
      </div>
    </div>
  </div>

  <div class="login-right">
    <div class="login-form-wrapper">

      <!-- Mobile logo -->
      <div class="text-center d-lg-none mb-4">
        <img src="../../../assets/img/bharat-logo.png" alt="Logo" class="login-mobile-logo" />
        <h5 class="login-mobile-title">Bharat BoudhIKS</h5>
      </div>

      <div class="login-form-card">
        <div class="login-form-header">
          <div class="login-icon-wrap">
            <i class="bi bi-person-fill"></i>
          </div>
          <h4 class="login-title">Welcome Back</h4>
          <p class="login-subtitle">Sign in to your account to continue</p>
        </div>

        <div [formGroup]="loginForm">
          <!-- Email -->
          <div class="login-field-group">
            <label class="login-label" for="floatingInput">
              <i class="bi bi-envelope me-1"></i> Email Address
            </label>
            <input
              type="email"
              class="login-input"
              id="floatingInput"
              formControlName="userName"
              placeholder="Enter your email"
              [ngClass]="{ 'login-input-error': submitted && f.userName.errors }"
            />
            <div *ngIf="submitted && f.userName.errors" class="login-error-msg">
              <i class="bi bi-exclamation-circle me-1"></i>
              <span *ngIf="f.userName.errors.required">Email is required</span>
            </div>
          </div>

          <!-- Password -->
          <div class="login-field-group">
            <label class="login-label" for="floatingPassword">
              <i class="bi bi-lock me-1"></i> Password
            </label>
            <div class="login-password-wrap">
              <input
                class="login-input"
                id="floatingPassword"
                formControlName="password"
                placeholder="Enter your password"
                [type]="fieldTextType ? 'text' : 'password'"
                [ngClass]="{ 'login-input-error': submitted && f.password.errors }"
                (keydown.enter)="registerUser()"
              />
              <button type="button" class="login-eye-btn" (click)="toggleFieldTextType()" tabindex="-1">
                <i class="fa" id="viewPassword"
                  [ngClass]="{ 'fa-eye-slash': !fieldTextType, 'fa-eye': fieldTextType }"></i>
              </button>
            </div>
            <div *ngIf="submitted && f.password.errors" class="login-error-msg">
              <i class="bi bi-exclamation-circle me-1"></i>
              <span *ngIf="f.password.errors.required">Password is required</span>
            </div>
          </div>

          <!-- Forgot password link -->
          <div class="login-forgot-row">
            <a class="login-forgot-link" data-bs-toggle="modal" data-bs-target="#exampleModal">
              Forgot password?
            </a>
          </div>

          <!-- Login button -->
          <button class="login-submit-btn" (click)="registerUser()">
            <i class="bi bi-box-arrow-in-right me-2"></i> Sign In
          </button>
        </div>

        <!-- Footer links -->
        <div class="login-footer-links">
          <div class="login-footer-item">
            <span>New institution?</span>
            <a (click)="gotoSchoolRegister()">Register here</a>
          </div>
          <div class="login-footer-item">
            <span>Don't have an account?</span>
            <a (click)="gotoSignUp()">Sign Up</a>
          </div>
        </div>
      </div>

      <p class="login-copyright">© 2025 Bharat BoudhIKS. All rights reserved.</p>
    </div>
  </div>
</div>

<!-- ===================== FORGOT PASSWORD MODAL ===================== -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow-lg" style="border-radius: 16px; overflow: hidden;">
      <div class="modal-header border-0 pb-0" style="background: linear-gradient(135deg, #1a3c6e, #2563a8); color: #fff;">
        <div class="d-flex align-items-center gap-2">
          <div style="width:36px;height:36px;background:rgba(255,255,255,0.2);border-radius:50%;display:flex;align-items:center;justify-content:center;">
            <i class="bi bi-shield-lock-fill" style="font-size:16px;"></i>
          </div>
          <h5 class="modal-title mb-0 fw-semibold" id="exampleModalLabel">Reset Password</h5>
        </div>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body px-4 pt-4">
        <p class="text-muted mb-3" style="font-size:14px;">Enter your registered email address and we'll send you a reset link.</p>
        <label class="form-label fw-semibold" style="font-size:13px; color:#374151;">Email Address</label>
        <div class="input-group">
          <span class="input-group-text bg-light border-end-0" style="border-radius:10px 0 0 10px;">
            <i class="bi bi-envelope text-muted"></i>
          </span>
          <input
            type="email"
            class="form-control border-start-0 ps-0"
            placeholder="you@example.com"
            (blur)="validateEmail($event)"
            [(ngModel)]="emailId"
            [ngModelOptions]="{ standalone: true }"
            style="border-radius:0 10px 10px 0; font-size:14px;"
          />
        </div>
      </div>
      <div class="modal-footer border-0 px-4 pb-4 gap-2">
        <button type="button" class="btn btn-light px-4" id="md_close" (click)="close()" data-bs-dismiss="modal"
          style="border-radius:10px; font-size:14px; font-weight:500;">
          Cancel
        </button>
        <button type="button" class="btn px-4" (click)="onForgotPasswordClick()"
          style="background:linear-gradient(135deg,#1a3c6e,#2563a8);color:#fff;border-radius:10px;font-size:14px;font-weight:600;border:none;">
          <i class="bi bi-send me-1"></i> Send Reset Link
        </button>
      </div>
    </div>
  </div>
</div>

<app-login-two *ngIf="isBool"></app-login-two>
<app-alumini-login *ngIf="aluminiLogin"></app-alumini-login>
